import {
	loginWithCredential,
	loginWithProvider,
	logout,
	resetPassword,
	updatePassword,
} from '../../apis';

import { useMutation } from '@tanstack/react-query';

const useFirebaseAuthMutations = () => {
	const firebaseLoginWithCredential = useMutation({ mutationFn: loginWithCredential });
	const firebaseLoginWithProvider = useMutation({ mutationFn: loginWithProvider });
	const resetPasswordMutation = useMutation({ mutationFn: resetPassword });
	const updatePasswordMutation = useMutation({ mutationFn: updatePassword });
	const firebaseLogoutMutation = useMutation({ mutationFn: logout });

	return {
		firebaseLoginWithCredential,
		firebaseLoginWithProvider,
		resetPasswordMutation,
		updatePasswordMutation,
		firebaseLogoutMutation,
	};
};

export default useFirebaseAuthMutations;